(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* Countdown */
  $$('[data-countdown]').forEach((el) => {
    const daily = el.dataset.daily === 'true';
    const end = daily ? null : new Date(el.dataset.end);
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const now = new Date();
      let target = end;
      if (daily || !end || isNaN(end)) { target = new Date(now); target.setHours(24, 0, 0, 0); }
      let diff = Math.max(0, target - now);
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      $('[data-d]', el).textContent = pad(d); $('[data-h]', el).textContent = pad(h);
      $('[data-m]', el).textContent = pad(m); $('[data-s]', el).textContent = pad(s);
    };
    tick(); setInterval(tick, 1000);
  });

  /* Sliders (scroll-snap based) */
  const initSlider = (root) => {
    const track = $('[data-slider-track]', root);
    if (!track || track.dataset.ready) return; track.dataset.ready = '1';
    const slides = () => Array.from(track.children);
    const dots = $$('[data-slider-dots] button', root);
    const counter = $('[data-slider-counter]', root);
    const thumbs = $$('[data-thumb]', root.closest('[data-gallery]') || root);
    const index = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => { const n = slides().length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    const sync = () => {
      const i = index();
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
      if (counter) counter.textContent = `${i + 1} / ${slides().length}`;
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dots.forEach((d, j) => d.addEventListener('click', () => go(j)));
    thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.thumb)));
    $('[data-slider-prev]', root)?.addEventListener('click', () => go(index() - 1));
    $('[data-slider-next]', root)?.addEventListener('click', () => go(index() + 1));
    const secs = +root.dataset.autoplay || 0;
    if (secs > 0 && slides().length > 1) {
      let timer = setInterval(() => go(index() + 1), secs * 1000);
      root.addEventListener('pointerenter', () => clearInterval(timer));
      root.addEventListener('pointerleave', () => { clearInterval(timer); timer = setInterval(() => go(index() + 1), secs * 1000); });
    }
    root._goTo = go;
    sync();
  };
  $$('[data-slider]').forEach(initSlider);

  /* Horizontal product rows */
  $$('[data-scroll-row]').forEach((row) => {
    const wrap = row.closest('section');
    const step = () => row.clientWidth * 0.8;
    $('[data-scroll-prev]', wrap)?.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-scroll-next]', wrap)?.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* Drawers */
  const openEl = (el) => { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); };
  const closeEl = (el) => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };
  const menu = $('[data-menu]');
  $('[data-menu-open]')?.addEventListener('click', () => openEl(menu));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => closeEl(menu)));
  const drawer = $('[data-cart-drawer]');
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => { if (!drawer) return; e.preventDefault(); openEl(drawer); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => closeEl(drawer)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { menu && closeEl(menu); drawer && closeEl(drawer); } });

  const refreshCart = async () => {
    const html = await (await fetch(`${window.theme.routes.cart_url}?view=drawer`, { credentials: 'same-origin' })).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrap = doc.querySelector('[data-count]');
    if (!wrap) return;
    $('[data-cart-body]').innerHTML = wrap.innerHTML;
    $$('[data-cart-count]').forEach((c) => { c.textContent = wrap.dataset.count; c.toggleAttribute('data-zero', wrap.dataset.count === '0'); });
  };
  $$('[data-cart-count]').forEach((c) => c.toggleAttribute('data-zero', c.textContent.trim() === '0'));

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    btn.disabled = true;
    await fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: +btn.dataset.line, quantity: +btn.dataset.qtyChange })
    });
    await refreshCart();
  });

  /* Product form */
  $$('[data-qty-input]').forEach((q) => {
    const input = $('input', q);
    $$('[data-step]', q).forEach((b) => b.addEventListener('click', () => { input.value = Math.max(1, (+input.value || 1) + +b.dataset.step); }));
  });

  $$('[data-product-section]').forEach((section) => {
    const data = JSON.parse($('[data-product-json]', section)?.textContent || '{}');
    const form = $('[data-product-form]', section);
    const picker = $('[data-variant-picker]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const defaultLabel = addLabel ? addLabel.textContent : '';
    const priceEl = $('[data-price]', section);
    const slider = $('[data-slider]', section);

    const selected = () => {
      const opts = [];
      $$('input[data-option-index]:checked', section).forEach((r) => { opts[+r.dataset.optionIndex] = r.value; });
      return opts;
    };
    const findVariant = (opts) => (data.variants || []).find((v) => v.options.every((o, i) => o === opts[i]));

    const markAvailability = (opts) => {
      $$('input[data-option-index]', section).forEach((r) => {
        const i = +r.dataset.optionIndex;
        const test = opts.slice(); test[i] = r.value;
        const v = findVariant(test);
        r.closest('.pill, .pair-picker__card')?.classList.toggle('is-unavailable', !v || !v.available);
      });
    };

    const update = () => {
      const opts = selected();
      opts.forEach((o, i) => { const l = $(`[data-option-label="${i}"]`, picker); if (l) l.textContent = o; });
      const v = findVariant(opts);
      $$('[data-pack-price]', section).forEach((el) => { const packOpts = opts.slice(); packOpts[2] = el.dataset.packPrice; const packVariant = findVariant(packOpts); el.textContent = packVariant ? packVariant.price : '—'; });
      markAvailability(opts);
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Ej tillgänglig'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? defaultLabel : 'Slutsåld';
      $$('[data-pair-price]', section).forEach((el) => { el.textContent = v.pair_prices?.[+el.dataset.pairPrice] || v.price; });
      if (priceEl) {
        $('[data-price-current]', priceEl).textContent = v.price;
        let cmp = $('[data-price-compare]', priceEl), badge = $('[data-price-badge]', priceEl);
        priceEl.classList.toggle('price--sale', !!v.compare);
        if (cmp) { cmp.textContent = v.compare || ''; cmp.hidden = !v.compare; }
        if (badge) { badge.textContent = `Spara ${v.saving}%`; badge.hidden = !v.compare; }
      }
      if (v.media && slider && slider._goTo) {
        const idx = (data.media || []).indexOf(v.media);
        if (idx >= 0) slider._goTo(idx);
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    };
    if (picker) { section.addEventListener('change', (event) => { if (event.target.matches('input[data-option-index]')) update(); }); markAvailability(selected()); }

    form?.addEventListener('submit', async (e) => {
      if (!drawer) return;
      e.preventDefault();
      const err = $('[data-form-error]', section);
      addBtn.disabled = true; addBtn.classList.add('is-loading');
      try {
        const res = await fetch(window.theme.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || 'Något gick fel');
        if (err) err.hidden = true;
        await refreshCart();
        openEl(drawer);
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
      } finally {
        addBtn.disabled = false; addBtn.classList.remove('is-loading');
      }
    });
  });

  /* Related products */
  $$('[data-related]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-related]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (_) {}
  });
})();
